export const translateUnixBreaksToHtml = (text: string) => text.replace(/\n/g, '<br>');
